<template>
  <div class="trip-report-main">
    <div class="sidenav" :style="{ width: menuOpen ? `${menuWidth}px` : '50px', paddingTop: menuOpen ? '5px' : '28px'}">
      <div class="refreshButton">
        <img src="https://img.icons8.com/material-rounded/96/000000/double-left.png" :style="{transform: menuOpen ? `rotate(0deg)` : 'rotate(-180deg)', margin: '3px'} " @click ="menuOpen ^= true"/>
      </div>

      <!-- <div class="left-filters" style="text-align: center; height: auto; position: relative; top: 90px;"> -->
      <div class="left-filters" style="height: auto; position: relative; top: 90px;">
        <button v-show="menuOpen" @click="showConsignment = !showConsignment" style="width: calc(100% - 10px); margin: 5px;">{{ !showConsignment ? 'Consignment' : 'Job' }}</button>
        <button :style="{ width: menuOpen ? `calc(100% - 10px)` : '40px', top: menuOpen ? '' : '-70px', position: 'relative', margin: '5px', padding: '5px'}" title = "Refresh" @click="refreshClicked">
          <img v-show="!menuOpen" style="width:25px; height: 25px;" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png"/>  {{menuOpen? 'Refresh' : ''}}
        </button>

        <DateTimePicker v-show="menuOpen" placeholder="Start" title="Start Date" :showTime="false" style="padding: 5px; width: 100%;" :value.sync="filterStartDate" />
        <DateTimePicker v-show="menuOpen" placeholder="End" title="End Date" :showTime="false" style="padding: 5px; width: 100%;" :value.sync="filterEndDate" />
        <Filters v-show="menuOpen" class="customer-filter" style="width: 100%; height: 150px; padding: 5px;" title="Customer" :tableData="customerList" itemKey="Customer Code" itemDesc="Customer Code" :selectedObject.sync="filterCustomer" />
        <button v-show="menuOpen" @click="showRightMenu = !showRightMenu" style="width: calc(100% - 10px); margin: 5px;">Update Status</button>
        <button v-show="menuOpen" @click="generateKPIReport" style="width: calc(100% - 10px); margin: 5px;" :disabled="disabledGenerateKPIButton == true ? true : false" >Generate KPI Report</button>
        <!-- <Filters class="charges-filter" title="Charges Code" :tableData="chargesCode" itemKey="Charge Code" itemDesc="Description" :selectedObject.sync="selectedChargesCode" @click.native="showInfoPopup = false"/> -->
        <!-- <Dropdown v-show="menuOpen" placeholder="Customer" :items="customerList" itemKey="Customer Code" :selectedObject.sync="filterCustomer" style="width: 95%;" ref="customer"/> -->

        <!-- <input type="checkbox" placeholder='Update with Same Location' :value='true'> -->
      </div>
    </div>

    <div class="right-container">
      <div class="top-filter">
        <div class="refresh-details"><div class="caption">Last Refreshed</div>: {{lastRefresh}}</div>
        <div class="refresh-details"><div class="caption">Start Date</div>: {{startDate}}</div>
        <div class="refresh-details"><div class="caption">End Date</div>: {{endDate}}</div>
        <div class="refresh-details"><div class="caption">Customer</div>: {{customerSelected ? customerSelected : 'All'}}</div>
      </div>
      <div class="table">
        <div class="table-container">
          <TableBox :style="{ opacity: showConsignment ? 0 : 1, zIndex: showConsignment ? -1 : 5 }" :downloadName="`TripReport${downloadName}`" :tableData="tripReportList" title="Trip Report (Job)"
            :loading="tableLoading" :dataType="{ 'Date': 'date', 'Sum Of TB': 'number', 'Sum Of Ctn': 'number', 'Sum Of TB+Ctn': 'number'}" :selectedRow.sync="selectedJob"
            :excelColumns="excelColumns" :additionalButtons="[{ text: 'Attachment', index: 0, width: 110 }]" :stickColumn="[0]" @buttonClicked="jobAttachmentClicked" 
            :columnOrderViews.sync="jobTableBoxColumnOrderViews" :columnOrderID="jobTableBoxColumnOrderID"/>
        </div>
        <div :style="{ opacity: !showConsignment ? 0 : 1, zIndex: !showConsignment ? -1 : 5 }" class="table-container">
          <TableBox title="Trip Report (Consignment)" :tableData="cnReportList" :loading="cnTableLoading" 
            :columnOrderViews.sync="cnTableBoxColumnOrderViews" :columnOrderID="cnTableBoxColumnOrderID"/>
        </div>
      </div>
    </div>

    <div class="attachment-popup" v-if="showConsignmentPopup">
      <div class="content">
        <img src="https://dsmlib.logistics.systems/Icons/Next.png" v-if="currentAttachmentIndex > 0" class="left-icon" @click="changeAttachmentIndex('MINUS')">
        <img src="https://dsmlib.logistics.systems/Icons/Next.png" v-if="currentAttachmentIndex < attachmentList.length - 1" class="right-icon" @click="changeAttachmentIndex('ADD')">
        <img src="https://dsmlib.logistics.systems/Icons/Cancel.png" class="close-icon" @click="showConsignmentPopup = false">
        <div class="title">{{ currentAttachmentDetails['Job No'] }} ({{ currentAttachmentDetails['Consignment No'] }})</div>
        <div class="title">Attachment {{ currentAttachmentIndex + 1 }} of {{ attachmentList.length }}</div>
        <object v-if="showCurrentAttachment" :data="currentAttachmentDetails['AttImage']"></object>
        <div class="caption">{{ currentAttachmentDetails['AttImageName'] }}</div>
      </div>
    </div>

    <RightMenu :showMenu.sync="showRightMenu" :showCloseButton="true">
      <div class="right-menu">
        <!-- Header -->
        <div class="RMheader">
          <p style="font-size: 1.2em; font-weight: bold; margin: 5px;">Update Job Status</p>
          <div class="RMmaindetails">
            <!-- <div class="RMdetails"><div class="RMcaption">Job No</div>: {{selectedJob[0] ? selectedJob[0]['Job Ref'] : ''}}</div>
            <div class="RMdetails"><div class="RMcaption">Journey Assigned</div>: {{selectedJob[0] ? selectedJob[0]['Journey Assigned'] : ''}}</div>
            <div class="RMdetails"><div class="RMcaption">Destination</div>: {{selectedJob[0] ? '(' + selectedJob[0]['Store-M'].trim() + ') ' + selectedJob[0]['Store Name'] : ''}}</div>           -->
            <div class="RMdetails"><div class="RMcaption">Job No</div>: {{selectedJobJobNo}}</div>
            <!-- <div class="RMdetails"><div class="RMcaption">Journey Assigned</div>: {{selectedJobJourneyAssigned}}{{selectedJobJourneyAssigned == 'Pending' ? '(' + selectedJobLegsNotAssigned + ')' : ''}}</div> -->
            <div class="RMdetails"><div class="RMcaption">Journey Assigned</div>: {{selectedJobJourneyAssigned == 'Pending' ? selectedJobJourneyAssigned + '(' + selectedJobLegsNotAssigned + ')' : selectedJobJourneyAssigned}}</div>
            <div class="RMdetails"><div class="RMcaption">Destination</div>: {{selectedJobDestinationCode ? '(' + selectedJobDestinationCode + ')' + selectedJobDestinationName : ''}}</div>          
          </div>
        </div>
        <CheckBox class="updateAllCheckBox" title="Update All Job With Same Location" :isChecked.sync="updateSameLocation" />
        <!-- Header -->
        <!-- Body -->
        <div class="RMbody">
          <div v-for="(data,index) in tripReportLegList" :key="index">
            <div class="RMleg">
              <div class="RMlegdetails">
                <p>Leg {{data['Leg']}} ({{data['Departure']}} - {{data['Destination']}})</p>
                <button disabled="true" style="background-color: red; right: 5px; top: 0px; position: absolute;">Fail</button>
                <div class="RMdetails"><div class="RMcaption">Journey No</div>: {{data['TMSJINo']}}</div>
                <div class="RMdetails"><div class="RMcaption">Truck</div>: {{data['Truck']}}</div>
                <div class="RMdetails"><div class="RMcaption">Driver</div>: {{data['Driver']}}</div>
              </div>
              <div class="RMmainstatus">
                  <!-- <div v-for="(data1, index1) in statusArray" :key="index1" class="RMstatus" :style="{marginRight: (index1 % 2 == 0) ? '2.5px' : '', marginLeft: (index1 % 2 != 0) ? '2.5px' : '', backgroundColor: data[`${data1['status']}Color`]}"> -->
                    <div v-for="(data1, index1) in statusArray" :key="index1" class="RMstatus" :style="{marginLeft: (index1 % 2 == 0) ? '5px' : '', 
                    width: (index1 % 2 !== 0) ? 'calc(100% - 5px)' : '', backgroundColor: data[`${data1['status']}Color`], 
                    pointerEvents: data[`${data1['status']}Dsbl`] == 'YES' ? 'none' : '', opacity: data[`${data1['status']}Dsbl`] == 'YES' ? '0.4' : ''}">
                      <div class="RMstatushead">
                        <p>{{data1['name']}}</p>
                        <!-- {{data[`${data1['status']}Dsbl`]}} -->
                        <button :disabled="data[data1['status']] ? false : true" @click="getAllJobSameLocation(data, data1['status'])" class="statusbutton">Update</button>
                      </div>
                      <DateTimePicker :value.sync="data[data1['status']]" />
                    </div>
                <!-- <div class="RMstatus" :style="{marginRight: '2.5px', backgroundColor: data['PUIColor']}">
                  <div class="RMstatushead">
                    <p>PICK UP IN</p>
                    <Button class="statusbutton">Update</Button>
                  </div>
                  <DateTimePicker :value.sync="data['PUI']" />
                </div>
                <div class="RMstatus" :style="{marginLeft: '2.5px', backgroundColor: data['PUOColor']}">
                  <div class="RMstatushead">
                    <p>PICK UP OUT</p>
                    <Button class="statusbutton">Update</Button>
                  </div>
                  <DateTimePicker :value.sync="data['PUO']" />
                </div> -->
              </div>
              <!-- <div class="RMmainstatus">
                <div class="RMstatus" :style="{marginRight: '2.5px', backgroundColor: data['DOIColor']}">
                  <div class="RMstatushead">
                    <p>DROP OFF IN</p>
                    <Button class="statusbutton">Update</Button>
                  </div>
                  <DateTimePicker :value.sync="data['DOI']" />
                </div>
                <div class="RMstatus" :style="{marginLeft: '2.5px', backgroundColor: data['DOOColor']}">
                  <div class="RMstatushead">
                    <p>DROP OFF OUT</p>
                    <Button class="statusbutton">Update</Button>
                  </div>
                  <DateTimePicker :value.sync="data['DOO']" />
                </div>
              </div> -->
            </div>
          </div>

          <!-- <div class="RMleg1" :style="{display: selectedJobLeg1Display, backgroundColor: 'white', marginTop: '5px'}">
            <div class="RMleg1details">
              <p style="font-size: 1.1em; font-weight: bold; margin-top: 3px; margin-bottom: 3px;">Leg 1 ({{selectedJobLeg1Departure}} - {{selectedJobLeg1Destination}})</p>
              <div class="RMdetails"><div class="RMcaption">Journey No</div>: {{selectedJobLeg1TMSJINo}}</div>
              <div class="RMdetails"><div class="RMcaption">Truck</div>: {{selectedJobLeg1Truck}}</div>
              <div class="RMdetails"><div class="RMcaption">Driver</div>: {{selectedJobLeg1Driver}}</div>
            </div>
            <div class="RMpickup" style="display: flex; display-direction: row; ">
              <div class="RMpickupin" :style="leftDatePickerStyling">
                <div style="display: flex; display-direction: column;">
                  <p>PICK UP IN</p>
                  <Button @click="rightMenuSaved('PICKUPIN')">Update</Button>
                </div>
                <DateTimePicker :value.sync="selectedJobLeg1PUI" :isDisabled="selectedJobLeg1Disabled" />
              </div>
              <div class="RMpickupout" :style="{marginLeft: '2.5px', backgroundColor: selectedJobLeg1PUOColor}">
                <p>PICK UP OUT</p>
                <DateTimePicker :value.sync="selectedJobLeg1PUO" :isDisabled="selectedJobLeg1Disabled" />
              </div>
            </div>
            <div class="RMdropoff" style="display: flex; display-direction: row;">
              <div class="RMdropoffin" :style="{marginRight: '2.5px', backgroundColor: selectedJobLeg1DOIColor}">
                <p>DROP OFF IN</p>
                <DateTimePicker :value.sync="selectedJobLeg1DOI" :isDisabled="selectedJobLeg1Disabled" />
              </div>
              <div class="RMdropoffout" :style="{marginLeft: '2.5px', backgroundColor: selectedJobLeg1DOOColor}">
                <p>DROP OFF OUT</p>
                <DateTimePicker :value.sync="selectedJobLeg1DOO" :isDisabled="selectedJobLeg1Disabled" />
              </div>
            </div>
          </div> -->
        </div>
        <!-- Body -->

        <!-- Footer -->
        <div class="RMfooter">
          <div class="message-box" ref="msgbox"><div :style="{backgroundColor: updateResult ? 'rgba(255, 246, 121, 0.37)' : 'rgba(255,255,255)', padding: '5px;'}" v-html="updateResult"></div></div>
          <!-- <div class="message-box" ref="msgbox"><div style="padding: 5px;" v-html="updateResult"></div></div> -->
          <div class="save-all-div"><button disabled="true" class="save-all" @click="rightMenuSaved('ALL')">Save All</button></div>
        </div>
        <!-- Footer -->
      </div>
    </RightMenu>

    <Loader :isVisible="loading" :loadingText="loadingText"/>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';
import XLSX from 'xlsx-js-style';

export default {
  components: {
  },

  props: {
    startDate: { type: Date, default: null},
    endDate: { type: Date, default: null},
  },

  data: function() {
    return {
      loading: false,
      loadingText: '',

      a: '1',
      //common
      userid: null, 
      coname: null,
      //filtered variable
      lastRefresh: '',
      startDate: '',
      filterStartDate: null,
      endDate: '',
      filterEndDate: null,
      //dropdown list
      customerList: [],
      customerSelected:'',
      filterCustomer: [],
      //left panel
      menuOpen: true,
      menuWidth: 200,
      //table
      tripReportList: [],
      tripReportLegList: [],
      tripReportLegListORI: [],
      tableLoading : false,
      downloadName : '',
      selectedJob: [],
      jobTableBoxColumnOrderViews: [],
      jobTableBoxColumnOrderID: '',
      cnTableBoxColumnOrderViews: [],
      cnTableBoxColumnOrderID: '',

      cnReportList: [],
      cnTableLoading: false,

      showCurrentAttachment: true,
      currentAttachmentIndex: 0,
      currentAttachmentDetails: null,
      attachmentList: [],

      showConsignmentPopup: false,

      disabledGenerateKPIButton: true,

      excelColumns: [
        { "key": "Date", "title": "Date" },
        { "key": "Day", "title": "Day" },
        { "key": "Str No", "title": "Str No" },
        { "key": "Job Ref", "title": "Job Ref" },
        { "key": "Store-M", "title": "Store-M" },
        { "key": "Zone Mapping", "title": "Zone Mapping" },
        { "key": "Store name", "title": "Store Name" },
        { "key": "District/City/Town", "title": "District.City/Town" },
        { "key": "State", "title": "State" },
        { "key": "Farthest Destination For The Trip", "title": "Farthest Destination For The Trip" },
        { "key": "Sum Of TB", "title": "Sum Of TB" },
        { "key": "Sum Of Ctn", "title": "Sum Of Ctn" },
        { "key": "Sum Of TB+Ctn", "title": "Sum Of TB+Ctn" },
        { "key": "Leg1 Trucks", "title": "Leg 1 Trucks" },
        { "key": "Leg1 Ton", "title": "Leg 1 Ton" },
        { "key": "Leg1 Drivers", "title": "Leg 1 Drivers" },
        { "key": "Leg1 Operator", "title": "Leg 1 Operator" },
        { "key": "Route", "title": "Route" },
        { "key": "Drop", "title": "Drop" },
        { "key": "Leg1 TMSJINo", "title": "Leg 1 TMSJINo" },
        { "key": "Leg2 Trucks", "title": "Leg 2 Trucks" },
        { "key": "Leg2 Ton", "title": "Leg 2 Ton" },
        { "key": "Leg2 Drivers", "title": "Leg 2 Drivers" },
        { "key": "Leg2 Operator", "title": "Leg 2 Operator" },
        { "key": "Leg2 TMSJINo", "title": "Leg 2 TMSJINo" },
        { "key": "Leg1 Pick Up In Date Update", "title": "Leg 1 Pick Up In"},
        { "key": "Leg1 Pick Up Out Date Update", "title": "Leg 1 Pick Up Out"},
        { "key": "Leg1 Drop Off In Date Update", "title": "Leg 1 Drop Off In"},
        { "key": "Leg1 Drop Off Out Date Update", "title": "Leg 1 Drop Off out"},
        { "key": "Leg2 Pick Up In Date Update", "title": "Leg 2 Pick Up In"},
        { "key": "Leg2 Pick Up Out Date Update", "title": "Leg 2 Pick Up Out"},
        { "key": "Leg2 Drop Off In Date Update", "title": "Leg 1 Drop Off In"},
        { "key": "Leg2 Drop Off Out Date Update", "title": "Leg 1 Drop Off Out"},
      ],

      excelFixedColumn: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
      excelColumnLetters: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],

      showConsignment: false,

      updateSameLocation: false,

      //#region RightMenu variables
      updateResult: '',
      showRightMenu: false,
      disabledColor: '#DCDCDC',
      pendingColor: '#FFFF99',//FFFF99
      completeColor: '#79D279', //79D279

      selectedJobJobNo: '',
      selectedJobJourneyAssigned: '',
      selectedJobTotalLegs: '',
      selectedJobLegsNotAssigned: '',
      selectedJobDestinationCode: '',
      selectedJobDestinationName: '',

      selectedJobSameUpdateLocation: [],
      selectedJobLeg1SamePickUp: [],
      selectedJobLeg1SameDropOff: [],
      selectedJobLeg2SamePickUp: [],
      selectedJobLeg2SameDropOff: [],
      selectedJobLegsNotAssignedArray: [],
      statusArray: [
          { "status": "PUI", "name": "PICK UP IN"},
          { "status": "PUO", "name": "PICK UP OUT"},
          { "status": "DOI", "name": "DROP OFF IN"},
          { "status": "DOO", "name": "DROP OFF OUT"}
        ],
      
      selectedJobLeg1Display: 'none',
      selectedJobLeg1Disabled: false, //for disabling leg 1 input
      selectedJobLeg1TMSJINo: '',
      selectedJobLeg1Departure: '',
      selectedJobLeg1Destination: '',
      selectedJobLeg1Truck: '',
      selectedJobLeg1Driver: '',
      selectedJobLeg1PUI: null,
      selectedJobLeg1PUO: null,
      selectedJobLeg1DOI: null,
      selectedJobLeg1DOO: null,
      selectedJobLeg1PUIOri: null,
      selectedJobLeg1PUOOri: null,
      selectedJobLeg1DOIOri: null,
      selectedJobLeg1DOOOri: null,
      selectedJobLeg1PUIColor: '',
      selectedJobLeg1PUOColor: '',
      selectedJobLeg1DOIColor: '',
      selectedJobLeg1DOOColor: '',

      selectedJobLeg2Display: 'none',
      selectedJobLeg2Disabled: false, //for disabling leg 2 input
      selectedJobLeg2TMSJINo: '',
      selectedJobLeg2Departure: '',
      selectedJobLeg2Destination: '',
      selectedJobLeg2Truck: '',
      selectedJobLeg2Driver: '',
      selectedJobLeg2PUI: null,
      selectedJobLeg2PUO: null,
      selectedJobLeg2DOI: null,
      selectedJobLeg2DOO: null,
      selectedJobLeg2PUIOri: null,
      selectedJobLeg2PUOOri: null,
      selectedJobLeg2DOIOri: null,
      selectedJobLeg2DOOOri: null,
      selectedJobLeg2PUIColor: '',
      selectedJobLeg2PUOColor: '',
      selectedJobLeg2DOIColor: '',
      selectedJobLeg2DOOColor: '',

      //post data
      leg1PUIDate: '',
      leg1PUITime: '',
      leg1PUODate: '',
      leg1PUOTime: '',
      leg1DOIDate: '',
      leg1DOITime: '',
      leg1DOODate: '',
      leg1DOOTime: '',

      leg2PUIDate: '',
      leg2PUITime: '',
      leg2PUODate: '',
      leg2PUOTime: '',
      leg2DOIDate: '',
      leg2DOITime: '',
      leg2DOODate: '',
      leg2DOOTime: '',

      //#endregion
    }
  },

  async mounted() {
    await this.getInitialData();

    var userDetails = await this.$apiCallV2(`/Login/GetDetails`);
    this.userid = userDetails.LoginUserId;
    this.coname = userDetails.CoName;
    console.log(userDetails);
    console.log(this.coname);
    this.filterStartDate = new Date();
    this.filterEndDate = new Date();
  },

  methods: {
    getInitialData: async function() {
      this.loadingText = 'Getting Data';
      this.isLoading = true;

      try {
        this.customerList = await this.$apiCallV2('/TripReport/GetListMaster?masterFile=billcust');
      }
      catch (e) {
        console.log(e)
        console.log('Error getting data from API');
        this.errorBoxColor('Error', 'Something went wrong.');
      }
    },

    refreshClicked: async function() {
      //-- refresh the APi and update the top bar filtered list.

      let temp = JSON.parse(JSON.stringify(this.selectedJob));
      console.log(temp);
      let jobref = temp.map(r => r['Job Ref']);
      console.log(jobref);

      this.tripReportList = [];
      this.cnReportList = [];
      this.tableLoading = true;
      this.cnTableLoading = true;
      this.selectedJob = [];
      this.jobTableBoxColumnOrderViews = [];
      this.jobTableBoxColumnOrderID = null;
      this.cnTableBoxColumnOrderViews = [];
      this.cnTableBoxColumnOrderID = null;

      this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
      this.startDate = this.filterStartDate ? this.$dateTime.getDateTime(this.filterStartDate, 'yyyy-MM-dd') : ''
      this.endDate = this.filterEndDate ? this.$dateTime.getDateTime(this.filterEndDate, 'yyyy-MM-dd') : ''

      console.log(this.filterCustomer);
      if (this.filterCustomer.length > 0)
      {
        // this.customerSelected = this.filterCustomer.map()
        this.customerSelected = this.filterCustomer.map(a => a['Customer Code']).join(',');
        console.log(this.customerSelected);
        // this.customerSelected = this.filterCustomer['Customer Code']
      } else {
        console.log(this.customerSelected)
        this.customerSelected = '';
      }
        console.log(this.customerSelected)
      
      const jobColumnOrderId = {
        formname: 'Trucking_TripReport',
        formctrlname: 'TripReportJob'
      }

      var tripReport = await this.$apiCallV2(`/TripReport/TripReport?startjobdate=${this.startDate}&endjobdate=${this.endDate}&cu_number=${this.customerSelected}`);
      this.jobTableBoxColumnOrderViews = await this.$apiCallV2('/TableBox/GetColumnOrder', jobColumnOrderId);
      
      if (tripReport && tripReport['TripReport'] && tripReport['TripReport']['List']) {
        this.tripReportList = tripReport['TripReport']['List'];
      } else {
        this.tripReportList = [];
      }
      this.jobTableBoxColumnOrderID = jobColumnOrderId;
      this.tableLoading = false;

      console.log(this.tripReportList);
      if (this.tripReportList.length > 0) {
        this.disabledGenerateKPIButton = false;
        let tempSelected = [];
        jobref.forEach(a => {
          console.log(a);
          let tempjob = this.tripReportList.find(b => b['Job Ref'] == a);
          console.log(tempjob)
          if (tempjob) {
            let index = this.tripReportList.indexOf(tempjob);
            console.log(index);
            if (index >= 0) {
              tempSelected.push(this.tripReportList[index]);
              console.log(this.selectedJob);
            }
          }
        })
        this.selectedJob = tempSelected;
      } else {
        this.disabledGenerateKPIButton = true;
      }

      this.downloadName = `_${this.startDate}to${this.endDate}`;

      const cnColumnOrderId = {
        formname: 'Trucking_TripReport',
        formctrlname: 'TripReportConsign'
      }
      let cnReport = await this.$apiCallV2(`/TripReport/TripReport?startjobdate=${this.startDate}&endjobdate=${this.endDate}&cu_number=${this.customerSelected}&level=consignment&caseString=${this.customerSelected}`);
      this.cnTableBoxColumnOrderViews = await this.$apiCallV2('/TableBox/GetColumnOrder', cnColumnOrderId);
      
      this.cnTableBoxColumnOrderID = cnColumnOrderId;
      if (cnReport && cnReport['TripReport'] && cnReport['TripReport']['List']) {
        this.cnReportList = cnReport['TripReport']['List'];
      } else {
        this.cnReportList = [];
      }
      this.cnTableLoading = false;
      
    },

    dataRefresh: async function() {
      this.tripReportList = [];
      this.cnReportList = [];
      this.tripReportLegList = [];
      this.tripReportLegListORI = [];
      // this.
    },

    jobAttachmentClicked: async function(text, data) {
      setTimeout(() => {
        this.selectedJob = [];
      }, 100);
      console.log(this.selectedJob);
      this.loading = true;
      this.loadingText = 'Getting Job Documents';
      let attachments = await this.$apiCallV2(`/TripReport/GetJobDocuments?jobno=${data['Job Ref'].trim()}`);
      this.loading = false;

      if (attachments.length > 0) {
        this.attachmentList = attachments;
        this.currentAttachmentIndex = 0;
        this.currentAttachmentDetails = this.attachmentList[this.currentAttachmentIndex];
        this.showCurrentAttachment = true;
        this.showConsignmentPopup = true;
      } else {
        this.$showAlert('error', 'No Attachments', `Job # ${data['Job Ref']} has no attachments`);
      }
    },

    rightMenuSaved: async function(status) {
      this.selectedJobSameUpdateLocation = [];
      this.selectedJobLeg1SamePickUp = [];
      this.selectedJobLeg1SameDropOff = [];
      this.selectedJobLeg2SamePickUp = [];
      this.selectedJobLeg2SameDropOff = [];

      console.log(this.tripReportLegList);
      console.log(this.tripReportLegListORI);
      //check tripreportleglist with tripreportleglistori to see Status(PUI, PUO, DOI, DOO) have difference or not. If yes then add "YES" to (Status)Diff value
      if (this.tripReportLegList.length > 0) {
        this.tripReportLegList.forEach ((data, trllindex) => {
          if (data['Leg']) {
            let tempdate = null;
            let tempdateori = null;
            
            this.statusArray.forEach ((status, statusindex) => {
              console.log(status['status'], trllindex);
              tempdate = null;
              tempdateori = null;
              tempdate = data[status['status']] ? data[status['status']].formatString('yyyy-MM-dd HH:mm') : '';
              console.log(this.tripReportLegListORI[trllindex][status['status']]);
              console.log(typeof(this.tripReportLegListORI[trllindex][status['status']]));
              tempdateori = this.tripReportLegListORI[trllindex][status['status']] ? new Date(this.tripReportLegListORI[trllindex][status['status']]).formatString('yyyy-MM-dd HH:mm') : '';
              if (tempdate != tempdateori) {
                data[`${status['status']}Diff`] = 'YES';
              }
            })
          }
        })
      }

      //check if the latter status datetime in status(PUI, PUO, DOI, DOO) is earlier than the previous one. If yes then add "ERROR" to = (Status)Error value
      

      console.log(this.tripReportLegList);
      console.log(this.tripReportLegListORI);
      let leg1PUI = this.selectedJobLeg1PUI ? this.selectedJobLeg1PUI.formatString('yyyy-MM-dd HH:mm') : '';
      let leg1PUIORI = this.selectedJobLeg1PUIOri ? this.selectedJobLeg1PUIOri.formatString('yyyy-MM-dd HH:mm') : '';
      let leg1PUO = this.selectedJobLeg1PUO ? this.selectedJobLeg1PUO.formatString('yyyy-MM-dd HH:mm') : '';
      let leg1PUOORI = this.selectedJobLeg1PUOOri ? this.selectedJobLeg1PUOOri.formatString('yyyy-MM-dd HH:mm') : '';
      let leg1DOI = this.selectedJobLeg1DOI ? this.selectedJobLeg1DOI.formatString('yyyy-MM-dd HH:mm') : '';
      let leg1DOIORI = this.selectedJobLeg1DOIOri ? this.selectedJobLeg1DOIOri.formatString('yyyy-MM-dd HH:mm') : '';
      let leg1DOO = this.selectedJobLeg1DOO ? this.selectedJobLeg1DOO.formatString('yyyy-MM-dd HH:mm') : '';
      let leg1DOOORI = this.selectedJobLeg1DOOOri ? this.selectedJobLeg1DOOOri.formatString('yyyy-MM-dd HH:mm') : '';
      
      

      if (leg1PUI != leg1PUIORI) {
        this.selectedJobLeg1SamePickUp.push(this.selectedJobJobNo + 'pui');
      }
      if (leg1PUO != leg1PUOORI) {
        this.selectedJobLeg1SamePickUp.push(this.selectedJobJobNo + 'puo');
      }
      if (leg1DOI != leg1DOIORI) {
        this.selectedJobLeg1SameDropOff.push(this.selectedJobJobNo + 'doi');
      }
      if (leg1DOO != leg1DOOORI) {
        this.selectedJobLeg1SameDropOff.push(this.selectedJobJobNo + 'doo');
      }

      if (this.selectedJobTotalLegs > 1) {
        let leg2PUI = this.selectedJobLeg2PUI ? this.selectedJobLeg2PUI.formatString('yyyy-MM-dd HH:mm') : '';
        let leg2PUIORI = this.selectedJobLeg2PUIOri ? this.selectedJobLeg2PUIOri.formatString('yyyy-MM-dd HH:mm') : '';
        let leg2PUO = this.selectedJobLeg2PUO ? this.selectedJobLeg2PUO.formatString('yyyy-MM-dd HH:mm') : '';
        let leg2PUOORI = this.selectedJobLeg2PUOOri ? this.selectedJobLeg2PUOOri.formatString('yyyy-MM-dd HH:mm') : '';
        let leg2DOI = this.selectedJobLeg2DOI ? this.selectedJobLeg2DOI.formatString('yyyy-MM-dd HH:mm') : '';
        let leg2DOIORI = this.selectedJobLeg2DOIOri ? this.selectedJobLeg2DOIOri.formatString('yyyy-MM-dd HH:mm') : '';
        let leg2DOO = this.selectedJobLeg2DOO ? this.selectedJobLeg2DOO.formatString('yyyy-MM-dd HH:mm') : '';
        let leg2DOOORI = this.selectedJobLeg2DOOOri ? this.selectedJobLeg2DOOOri.formatString('yyyy-MM-dd HH:mm') : '';

        if (leg2PUI != leg2PUIORI) {
        this.selectedJobLeg2SamePickUp.push(this.selectedJobJobNo + 'pui');
        }
        if (leg2PUO != leg2PUOORI) {
          this.selectedJobLeg2SamePickUp.push(this.selectedJobJobNo + 'puo');
        }
        if (leg2DOI != leg2DOIORI) {
          this.selectedJobLeg2SameDropOff.push(this.selectedJobJobNo + 'doi');
        }
        if (leg2DOO != leg2DOOORI) {
          this.selectedJobLeg2SameDropOff.push(this.selectedJobJobNo + 'doo');
        }
      }

    },

    statusIndividualSaved: async function(data, status) {
      // console.log(data);
      this.loading = true;
      this.loadingText = 'Updating Job Status';
      // console.log(status);
      // console.log(this.selectedJobSameUpdateLocation);
      let actstartdate = '';
      let actstarttime = '';
      let actfinishdate = '';
      let actfinishtime = '';
      actstartdate = status.endsWith('I') ? (data[`${status}`] ? data[`${status}`].formatString('yyyy-MM-dd') : '') : '';
      actstarttime = status.endsWith('I') ? (data[`${status}`] ? data[`${status}`].formatString('HHmm') : '') : '';
      // actstartdate = status.startsWith('P') ? (data[`${status}`] ? data[`${status}`].formatString('yyyy-MM-dd') : '') : '';
      // actstarttime = status.startsWith('P') ? (data[`${status}`] ? data[`${status}`].formatString('HHmm') : '') : '';
      actfinishdate = status.endsWith('O') ? (data[`${status}`] ? data[`${status}`].formatString('yyyy-MM-dd') : '') : '';
      actfinishtime = status.endsWith('O') ? (data[`${status}`] ? data[`${status}`].formatString('HHmm') : '') : '';
      // actfinishdate = status.startsWith('D') ? (data[`${status}`] ? data[`${status}`].formatString('yyyy-MM-dd') : '') : '';
      // actfinishtime = status.startsWith('D') ? (data[`${status}`] ? data[`${status}`].formatString('HHmm') : '') : '';

      console.log(this.selectedJobSameUpdateLocation);
      for (let a of this.selectedJobSameUpdateLocation) { // No need async
      // this.selectedJobSameUpdateLocation.forEach(async a => { // Need async to loop
        // console.log(a);
        let dataToPost = {
          'jobno':a['Job Ref'].trim(),
          'ccno':'',
          'remarks':'',
          'status':'', //empty for now
          'tmsjino':data['TMSJINo'],
          'journeyguid':'', //empty for now
          'lorryno':'', 
          'driver':'',
          'actstartdate':actstartdate,
          'actstarttime':actstarttime,
          'updateactstart':'', //empty for now
          'actfinishdate':actfinishdate,
          'actfinishtime':actfinishtime,
          'updateactfinish':'', //empty for now
          'update':status,
          // 'finish': status.startsWith('P') ? '0' : '1',
          'finish': status.endsWith('I') ? '0' : '1',
          'recievedby':'', //empty for now
          'signature':'', ///not used
          'emptytbcount':'', //empty 
          'returntbcount':'', //empty
          'tripremarks':'', //empty
          'failreason':'', 
          'failremarks':'',
          'action':'' //empty
        };
  
        console.log(dataToPost);
        // var postResult = await this.$axios.post('/TripReport/UpdateJITMSStatus', dataToPost);
        var postResult = await this.$apiCallV2('/TripReport/UpdateJITMSStatus', dataToPost);
        // console.log(postResult);
        this.updateResult = `${this.updateResult}${this.updateResult ? '<br>' : ''}${new Date().formatString("yyyy-MM-dd HH:mm:ss")}<br>${a['Job Ref'].trim()} ${status} updated.`;// this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss') 
      };
      this.loading = false;
      this.refreshClicked();
    },

    getAllJobSameLocation: async function(data, status) {
      // console.log(status);
      // console.log(data);
      // console.log(this.tripReportList);
      // console.log(this.updateSameLocation);

      this.selectedJobSameUpdateLocation = [];
      this.selectedJobLeg1SamePickUp = [];
      this.selectedJobLeg1SameDropOff = [];
      this.selectedJobLeg2SamePickUp = [];
      this.selectedJobLeg2SameDropOff = [];

      let sameLocationJob = [];
      let destination = '';
      destination = status.startsWith('P') ? 'Departure' : 'Destination';
      // sameLocationJob = this.tripReportList.filter(a => a[`Leg${data['Leg']} TMSJINo`].trim() == data['TMSJINo'].trim() && a[`Leg${data['Leg']} ${destination}`].trim() == data[`${destination}`].trim());
      if (this.updateSameLocation == true && status.trim() != 'FAIL') {
        sameLocationJob = this.tripReportList.filter(a => {
          if (a[`Leg${data['Leg']} TMSJINo`].trim() == data['TMSJINo'].trim() 
            && a[`Leg${data['Leg']} ${destination}`].trim() == data[`${destination}`].trim()
            // && (a['Job Ref'].trim() != data['JobNo'].trim()))
            )
          {
            // console.log(a[`Leg${data['Leg']} TMSJINo`].trim());
            // console.log(a[`Leg${data['Leg']} ${destination}`].trim());
            // console.log(a['Job Ref'].trim());
            return a;
          }
          // console.log(a);
          // console.log(a[`Leg${data['Leg']} TMSJINo`])
          // console.log(a[`Leg${data['Leg']} ${destination}`]);
          // console.log(data['TMSJINo']);
          // console.log(data[`${destination}`]);
          // console.log(a[`Leg${data['Leg']} TMSJINo`].trim() == data['TMSJINo'].trim());
          // console.log(a[`Leg${data['Leg']} ${destination}`].trim() == data[`${destination}`].trim());
          // console.log(a[`Leg${data['Leg']} TMSJINo`].trim() === data['TMSJINo'].trim() && a[`Leg${data['Leg']} ${destination}`] === data[`${destination}`].trim())
        });
      } else {
        sameLocationJob = this.tripReportList.filter(b => b['Job Ref'].trim() == data['JobNo'].trim());
      }

      this.selectedJobSameUpdateLocation = sameLocationJob;
      // if (destination == "Departure") {
      //   if (data['Leg'].trim() == '1') {
      //     this.selectedJobLeg1SamePickUp = sameLocationJob;
      //   } else if (data['Leg'].trim() == '2') {
      //     this.selectedJobLeg2SamePickUp = sameLocationJob;
      //   }
      // } else {
      //   if (data['Leg'].trim() == '1') {
      //     this.selectedJobLeg1SameDropOff = sameLocationJob;
      //   } else if (data['Leg'].trim() == '2') {
      //     this.selectedJobLeg2SameDropOff = sameLocationJob;
      //   }
      // }
      // console.log(sameLocationJob);
      // console.log(this.selectedJobSameUpdateLocation);
      
      this.statusIndividualSaved(data, status);

    },

    generateKPIReport: async function() {
      // let continueGenerate = await this.$showAlert('info', )
      // let continueSave = await this.$showAlert('warning', 'Record already exist!', `Are you sure you want to override previous record?`, [
      //       { text: 'Override', color: 'red', textColor: 'white' },
      //       { text: 'Cancel', color: 'gray', textColor: 'white' }
      //     ]);
        let excelColumnsKPI = [
          { "key": "Date", "title": "Date" },
          { "key": "Day", "title": "Day" },
          // { "key": "Str No", "title": "Str No" },
          { "key": "Store-M", "title": "Store-M" },
          { "key": "Zone Mapping", "title": "Zone Mapping" },
          { "key": "Store name", "title": "Store Name" },
          { "key": "District/City/Town", "title": "District.City/Town" },
          { "key": "State", "title": "State" },
          // { "key": "Job Ref", "title": "Job Ref" },
          // { "key": "Farthest Destination For The Trip", "title": "Farthest Destination For The Trip" },
          { "key": "Sum Of TB", "title": "Sum Of TB" },
          { "key": "Sum Of Ctn", "title": "Sum Of Ctn" },
          { "key": "Sum Of TB+Ctn", "title": "Sum Of TB+Ctn" },
          { "key": "Truck", "title": "Trucks"},
          { "key": "Operator", "title": "Vendor" },
          { "key": "Ton", "title": "Ton"},
          { "key": "Route", "title": "Route" },
          { "key": "Drop", "title": "Drop Points" },
          { "key": "Tmsjino", "title": "TS Manifest No. (POD)" },
          { "key": "OTAW ETA WH", "title":"ETA WH" },
          { "key": "OTAW Reach WH", "title": "Reach WH"},
          { "key": "OTAW PassFail", "title":"OTAW Pass/Fail"},
          { "key": "OTLW Loading", "title": "Loading"},
          { "key": "OTLW Finished", "title": "Finished"},
          { "key": "OTLW PassFail", "title": "OTLW Pass/Fail"},
          { "key": "OTAS ETA Store", "title": "ETA Store"},
          { "key": "OTAS Reach Store", "title": "Reach Store"},
          { "key": "OTAS PassFail", "title": "OTAS Pass/Fail"},
          { "key": "OTDS Left Store", "title": "Left Store"},
          { "key": "OTDS PassFail", "title": "OTDS Pass/Fail"}
        ];

      this.tripReportList;
      let kpiJson = this.tripReportList;
      console.log(kpiJson);
      let firstTMSJINo = kpiJson[0]['Leg1 TMSJINo'] ? kpiJson[0]['Leg1 TMSJINo'] : '';
      let usedTMSJINo = firstTMSJINo;
      let randomTime = Math.floor(Math.random() * (30 - 15 + 1)) + 15;
      kpiJson.forEach(a => {
        let currentTMSJINo = a['Leg1 TMSJINo'] ? a['Leg1 TMSJINo'] : '';
        if (usedTMSJINo.trim() != currentTMSJINo.trim()) {
          usedTMSJINo = currentTMSJINo;
          randomTime = Math.floor(Math.random() * (30 - 15 + 1)) + 15;
        }

        let jobType = a['Job Type'] ? a['Job Type'].trim() : '';
        var PUI = a['Leg1 Pick Up In Date Update'] ? new Date(a['Leg1 Pick Up In Date Update']) : null;
        let PUO = a['Leg1 Pick Up Out Date Update'] ? new Date(a['Leg1 Pick Up Out Date Update']) : null;
        let DOI = null;
        let DOO = null;
        let truck = '';
        let operator = '';
        let ton = '';
        let tmsjino = '';
        if (jobType == 'DIRECT DELIVERY') {
          DOI = a['Leg1 Drop Off In Date Update'] ? new Date(a['Leg1 Drop Off In Date Update']) : null;
          DOO = a['Leg1 Drop Off Out Date Update'] ? new Date(a['Leg1 Drop Off Out Date Update']) : null;
          truck = a['Leg1 Trucks'] ? a['Leg1 Trucks'] : '';
          operator = a['Leg1 Operator'] ? a['Leg1 Operator'] : '';
          ton = a['Leg1 Ton'] ? a['Leg1 Ton'] : '';
          tmsjino = a['Leg1 TMSJINo'] ? a['Leg1 TMSJINo'] : '';
        } else {
          DOI = a['Leg2 Drop Off In Date Update'] ? new Date(a['Leg2 Drop Off In Date Update']) : null;
          DOO = a['Leg2 Drop Off Out Date Update'] ? new Date(a['Leg2 Drop Off Out Date Update']) : null;
          truck = a['Leg2 Trucks'] ? a['Leg2 Trucks'] : '';
          operator = a['Leg2 Operator'] ? a['Leg2 Operator'] : '';
          ton = a['Leg2 Ton'] ? a['Leg2 Ton'] : '';
          tmsjino = a['Leg2 TMSJINo'] ? a['Leg2 TMSJINo'] : '';
        }

        a['Truck'] = truck;
        a['Operator'] = operator;
        a['Ton'] = ton;
        a['Tmsjino'] = tmsjino;

        let jobPickUpDate = null; //for getting the date of the job. Driver pickup the cargo should be 1 day before the job date. 
        jobPickUpDate = new Date(a['Date']);
        jobPickUpDate.setDate(jobPickUpDate.getDate() - 1);

        let OTAWETAWH = null;
        let OTAWPassFail = ''
        let OTLWLoading = null;
        let OTLWPassFail = '';
        let OTASETAStore = new Date(a['Date']).setHours(22);
        let OTASPassFail = '';
        let OTDSPassFail = '';
        if (PUI) {
          let tempLatestETAWH = new Date(a['Date']);
          tempLatestETAWH.setHours(4);
          OTAWETAWH = new Date(tempLatestETAWH);
          // if (PUI > tempLatestETAWH) {
          //   OTAWETAWH = new Date(tempLatestETAWH);
          // } else {

          // }
          // else {
          //   OTAWETAWH = new Date(PUI);

          //   console.log(OTAWETAWH);
          //   let tempotaw = new Date(PUI);
          //   console.log(jobPickUpDate.getDate());
          //   console.log(tempotaw.getDate());
          //   if (jobPickUpDate.getDate() != tempotaw.getDate()) {
          //     tempotaw.setDate(jobPickUpDate.getDate());
          //     console.log('different day');
          //   }

          //   tempotaw.setHours(22);
          //   tempotaw.setMinutes(0);

          //   console.log(PUI.toLocaleString([], { day: '2-digit', hour: '2-digit', minute: '2-digit'}));
          //   console.log(tempotaw.toLocaleString([], { day: '2-digit', hour: '2-digit', minute: '2-digit'}));
          //   console.log(PUI < tempotaw);

          //   // if (PUI.getTime() < tempotaw.getTime()) {
          //   if (PUI < tempotaw) {
          //     console.log('here testing');
          //     OTAWETAWH.setHours(22);
          //     OTAWETAWH.setMinutes(0);
          //     console.log(OTAWETAWH);
          //   } else {
          //     tempotaw.setHours(23);
          //     tempotaw.setMinutes(59);
          //     tempotaw.setSeconds(59);
          //     console.log(tempotaw.toLocaleString([], { hour: '2-digit', minute: '2-digit'}));
          //     // if (PUI.getTime() < tempotaw.getTime()) {
          //     if (PUI < tempotaw) {
          //       console.log('here testing2');
          //       OTAWETAWH.setHours(0);
          //       OTAWETAWH.setMinutes(0);
          //       console.log(OTAWETAWH);
          //     } else {
          //       console.log('here testing3');
          //       OTAWETAWH.setHours(4);
          //       OTAWETAWH.setMinutes(0);
          //       console.log(OTAWETAWH);
          //     }
          //   }
          // }
        }
        if (PUO) {
          OTLWLoading = new Date(PUO);
          // OTLWLoading = new Date(OTLWLoading.setMinutes(OTLWLoading.getMinutes() - 15));
          OTLWLoading = new Date(OTLWLoading.setMinutes(OTLWLoading.getMinutes() - randomTime));
        }
        a['OTAW ETA WH'] = OTAWETAWH ? OTAWETAWH.toLocaleString([], { hour: '2-digit', minute: '2-digit'}) : '';
        a['OTAW Reach WH'] = PUI ? new Date(PUI).toLocaleString([], { hour: '2-digit', minute: '2-digit'}) : '';
        a['OTLW Loading'] = OTLWLoading ? new Date(OTLWLoading).toLocaleString([], { hour: '2-digit', minute: '2-digit'}) : '';
        a['OTLW Finished'] = PUO ? new Date(PUO).toLocaleString([], { hour: '2-digit', minute: '2-digit'}) : '';
        a['OTAS ETA Store'] = OTASETAStore ? new Date(OTASETAStore).toLocaleString([], { hour: '2-digit', minute: '2-digit'}) : '';
        a['OTAS Reach Store'] = DOI ? new Date(DOI).toLocaleString([], { hour: '2-digit', minute: '2-digit'}) : '';
        a['OTDS Left Store'] = DOO ? new Date(DOO).toLocaleString([], { hour: '2-digit', minute: '2-digit'}) : '';
        if (a['OTAW ETA WH'] && PUI) {
          if (PUI > OTAWETAWH) {
            OTAWPassFail = 'Fail';
          } else {
            OTAWPassFail = 'Pass';
          }
        }
        if (a['OTLW Loading'] && a['OTLW Finished']) {
          let OTLWLoadingPlus1H = new Date(OTLWLoading.setMinutes(OTLWLoading.getMinutes() + 60));
          if (PUO > OTLWLoadingPlus1H) {
            OTLWPassFail = 'Fail';
          } else {
            OTLWPassFail = 'Pass';
          }
        }
        if (a['OTAS ETA Store'] && a['OTAS Reach Store']) {
          if (DOI > OTASETAStore) {
            OTASPassFail = 'Fail';
          } else {
            OTASPassFail = 'Pass';
          }
        }
        if (DOI && DOO) {
          let temp1Hour = new Date(DOI).setHours(DOI.getHours() + 1);
          if (DOO > temp1Hour) {
            OTDSPassFail = 'Fail';
          } else {
            OTDSPassFail = 'Pass';
          }
        }
        a['OTAW PassFail'] = OTAWPassFail ? OTAWPassFail : 'Fail';
        a['OTLW PassFail'] = OTLWPassFail ? OTLWPassFail : 'Fail';
        a['OTAS PassFail'] = OTASPassFail ? OTASPassFail : 'Fail';
        a['OTDS PassFail'] = OTDSPassFail ? OTDSPassFail : 'Fail';
      });
      let otawPass = kpiJson.filter(b => b['OTAW PassFail'] == 'Pass').length;
      let otlwPass = kpiJson.filter(c => c['OTLW PassFail'] == 'Pass').length;
      let otasPass = kpiJson.filter(d => d['OTAS PassFail'] == "Pass").length;
      let otdsPass = kpiJson.filter(e => e['OTDS PassFail'] == 'Pass').length;
      // let sumtb = kpijson.map(k => k['Sum Of TB'] ? Number(k['Sum Of TB']) : 0).reduce((a, b) => a + b, 0);
      let sumtb = kpiJson.map(a => a['Sum Of TB'] ? (Number.isNaN(Number(a['Sum Of TB'])) ? 0 : Number(a['Sum Of TB'])) : 0).reduce((a, b) => a + b, 0);
      let sumctn = kpiJson.map(a => a['Sum Of Ctn'] ? (Number.isNaN(Number(a['Sum Of Ctn'])) ? 0 : Number(a['Sum Of Ctn'])) : 0).reduce((a, b) => a + b, 0);
      let sumtbctn = kpiJson.map(a => a['Sum Of TB+Ctn'] ? (Number.isNaN(Number(a['Sum Of TB+Ctn'])) ? 0 : Number(a['Sum Of TB+Ctn'])) : 0).reduce((a, b) => a + b, 0);
      let totalroute = kpiJson.length;
      let totaldrop = kpiJson.map(a => a['Drop'] ? (Number.isNaN(Number(a['Drop'])) ? 0 : Number(a['Drop'])) : 0).reduce((a, b) => a + b, 0);
      let excelExportJson = {
        sumtb: sumtb,
        sumctn: sumctn,
        sumtbctn: sumtbctn,
        totalroute: totalroute,
        totaldrop: totaldrop,
        otawAchieved: `${parseFloat((otawPass / kpiJson.length) * 100).toFixed(2)}`,
        otlwAchieved: `${parseFloat((otlwPass / kpiJson.length) * 100).toFixed(2)}`,
        otasAchieved: `${parseFloat((otasPass / kpiJson.length) * 100).toFixed(2)}`,
        otdsAchieved: `${parseFloat((otdsPass / kpiJson.length) * 100).toFixed(2)}`,
        table: kpiJson
      };

      //#region export excel
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet([]);
      XLSX.utils.book_append_sheet(wb, ws, this.title);

      let arrayvalue = [];

      //must use ExcelColumns array.
      let allTitle = excelColumnsKPI.map(e => e['title']);
      let allKeys = excelColumnsKPI.map(e => e['key']);

      const merge = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, { s: { r: 0, c: 16 }, e: { r: 0, c: 26 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } }, { s: { r: 1, c: 3 }, e: { r: 1, c: 4 } }, { s: { r: 1, c: 16 }, e: { r: 2, c: 16 } }, { s: { r: 1, c: 19 }, e: { r: 2, c: 19 } }, { s: { r: 1, c: 22 }, e: { r: 2, c: 22 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } }, { s: { r: 2, c: 3 }, e: { r: 2, c: 4 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 6 } }, { s: { r: 3, c: 10 }, e: { r: 3, c: 12 } }, { s: { r: 3, c: 16 }, e: { r: 3, c: 18 } }, { s: { r: 3, c: 19 }, e: { r: 3, c: 21 } }, { s: { r: 3, c: 22 }, e: { r: 3, c: 24 } }, { s: { r: 3, c: 25 }, e: { r: 3, c: 26 } },
      ];
      ws["!merges"] = merge;

      let excelJson = [
        [
          {
            text: this.coname,
            font: {
              sz: 14,
              bold: true
            }
          },
          {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
          {
            text: 'KPIs',
            font: {
              sz: 14,
              bold: true
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFFFFF00'}}
          } 
        ],
        [
          {
            text: 'TRIPS DATA',
            font: {
              sz: 12,
              color: {rgb: 'FFFFFFFF'}
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FF800080'}}
          },
          {},
          {
            text: 'From',
            font: {
              sz: 12,
              color: {rgb: 'FFFFFFFF'}
            },
            alignment: {
              horizontal: 'center'
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FF800080'}},
            border: {
              left: {
                style: 'thin',
                color: {rgb: 'FFFFFFFF'}
              }
            }
          },
          {
            text: this.startDate,
            font: {
              sz: 12
            },
            alignment: {
              horizontal: 'center'
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
          {
            fill: {patternType: 'solid', fgColor: {rgb: 'FFFFFF00'}},
          },
          {
            text: 'Target',
            font: {
              sz: 12
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: '95.0%',
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFDAEEF3'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            fill: {patternType: 'solid', fgColor: {rgb: 'FFFFFF00'}},
          },
          {
            text: 'Target',
            font: {
              sz: 12
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: '95.0%',
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFDAEEF3'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            fill: {patternType: 'solid', fgColor: {rgb: 'FFFFFF00'}},
          },
          {
            text: 'Target',
            font: {
              sz: 12
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: '95.0%',
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFDAEEF3'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: 'Target',
            font: {
              sz: 12
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: '95.0%',
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFDAEEF3'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }
        ],
        [
          {
            text: this.customerSelected ? this.customerSelected : 'All',
            font: {
              sz : 12,
              color: {rgb: 'FFFFFFFF'}
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FF800080'}},
          },
          {},
          {
            text: 'To',
            font: {
              sz: 12,
              color: {rgb: 'FFFFFFFF'}
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FF800080'}},
            alignment: {
              horizontal: 'center'
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FFFFFFFF'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FFFFFFFF'}
              }
            }
          },
          {
            text: this.endDate,
            font: {
              sz: 12
            },
            alignment: {
              horizontal: 'center'
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
          {
            text: 'Achieved',
            font: {
              sz: 12
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: `${excelExportJson['otawAchieved']}%`,
            font: {
              sz: 12,
              color: {rgb: 95.0 > parseFloat(excelExportJson['otawAchieved']) ? 'FFFF0000' : 'FF000000'}
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFDAEEF3'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {},
          {
            text: 'Achieved',
            font: {
              sz: 12
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: `${excelExportJson['otlwAchieved']}%`,
            font: {
              sz: 12,
              color: {rgb: 95.0 > parseFloat(excelExportJson['otlwAchieved']) ? 'FFFF0000' : 'FF000000'}
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFDAEEF3'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {},
          {
            text: 'Achieved',
            font: {
              sz: 12
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: `${excelExportJson['otasAchieved']}%`,
            font: {
              sz: 12,
              color: {rgb: 95.0 > parseFloat(excelExportJson['otasAchieved']) ? 'FFFF0000' : 'FF000000'}
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFDAEEF3'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: 'Achieved',
            font: {
              sz: 12
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: `${excelExportJson['otdsAchieved']}%`,
            font: {
              sz: 12,
              color: {rgb: 95.0 > parseFloat(excelExportJson['otdsAchieved']) ? 'FFFF0000' : 'FF000000'}
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFDAEEF3'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
        ],
        [
          {
            text: 'To-date TotalS  --->>',
            font: {
              sz: 12,
              color: {rgb: 'FFFFFFFF'}
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FF0066CC'}},
            alignment: {
              horizontal: 'right'
            }
          }, {}, {}, {}, {}, {}, {},
          {
            text: excelExportJson['sumtb'],
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFCCFFFF'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: excelExportJson['sumctn'],
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFCCFFFF'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: excelExportJson['sumtbctn'],
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFCCFFFF'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            fill: {patternType: 'solid', fgColor: {rgb: 'FF0066CC'}},
          }, {}, {},
          {
            text: excelExportJson['totalroute'],
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFCCFFFF'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }, 
          {
            text: excelExportJson['totaldrop'],
            font: {
              sz: 12
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFCCFFFF'}},
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            fill: {patternType: 'solid', fgColor: {rgb: 'FF0066CC'}},
          }, 
          {
            text: 'OTAW',
            font: {
              sz: 11
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFFFFF00'}},
            alignment: {
              horizontal: 'center'
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }, 
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: 'OTLW',
            font: {
              sz: 11
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFFFFF00'}},
            alignment: {
              horizontal: 'center'
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }, 
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            text: 'OTAS',
            font: {
              sz: 11
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFFFFF00'}},
            alignment: {
              horizontal: 'center'
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }, 
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }, 
          {
            text: 'OTDS',
            font: {
              sz: 11
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFFFFF00'}},
            alignment: {
              horizontal: 'center'
            },
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          },
          {
            border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              bottom: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
          }
        ]
      ]

      // Populate your title
      let tempTitle = [];
      allTitle.forEach((a, i) => {
        tempTitle.push({
          text: a,
            font: {
              sz: 11
            },
            fill: {patternType: 'solid', fgColor: {rgb: 'FFB7DEE8'}},
            alignment: {
            horizontal: 'center',
            wrapText: true
          },
          border: {
              top: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              left: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              },
              right: {
                style: 'thin',
                color: {rgb: 'FF000000'}
              }
            }
        });
      });
      console.log(tempTitle);
      excelJson.push(tempTitle);
      console.log(excelJson);

      excelJson.forEach((ej, eji) => {
        XLSX.utils.sheet_add_aoa(ws, [ej.map(ej => ej['text'] || '')], { origin: `A${eji + 1}` });
        ej.forEach((ej1, eji1) => {
          let column = `${this.getColumnLetter(eji1)}${eji + 1}`;
          ws[column].s = ej1;
        })
      })

      // Populate the rows
      excelExportJson['table'].forEach((t) => {
        let row = [];
        allKeys.forEach((k) => row.push(t[k]));
        arrayvalue.push(row);
      })

      
      console.log(this.downloadName);
      XLSX.utils.sheet_add_aoa(ws, arrayvalue, { origin: 'A6'});
      XLSX.writeFile(wb, `KPIReport${this.downloadName ? `${this.downloadName.split(' ').join('_')}` : `${this.title.split(' ').join('_')}`}.xlsx`);
      //#endregion
    },

    getColumnLetter: function(index, initLetter) {
      let letters = [];
      
      let start = parseInt(index / 26);
      let letter = index % 26;
      letters.splice(0, 0, this.excelColumnLetters[letter]);
      while (start > 0) {
        letter = start % 26;
        letters.splice(0, 0, this.excelColumnLetters[letter - 1]);
        start -= 26;
      }

      return letters.join('');
    },

    changeAttachmentIndex: async function(change) {
      this.showCurrentAttachment = false;

      if (change == 'ADD') {
        this.currentAttachmentIndex++;
      } else if (change == 'MINUS') {
        this.currentAttachmentIndex--;
      }

      this.currentAttachmentDetails = this.attachmentList[this.currentAttachmentIndex]
      await this.$nextTick(() => this.showCurrentAttachment = true);
    }

    // appendStatusIcon: function(list) {
    //   let tripListwithIcon = list.forEach(t => {
        
    //   })
    // }
  },

  computed: {
    customerSelected(){
      if (this.customerSelected)
      {
        return this.customerSelected;
      }
    },

    // leftDatePickerStyling(index) {
    //   console.log(index);
    //   return {
    //     marginRight: '2.5px',
    //     backgroundColor: this.selectedJobLeg1PUIColor
    //   }
    // }    
  },

  watch: {
    showConsignmentPopup: async function(val) {
      if (!val) {
        let splitBySlash = this.attachmentList[0]['AttImage'].split('/');
        let config = splitBySlash[splitBySlash.length - 2];
        let jobNo = this.attachmentList[0]['Job No'];
        let a = await Axios.get(`/TripReport/DeleteDocuments?folders=${config},${jobNo}`);
        console.log(a.data);
      }
    },

    selectedJob(val) {
      this.tripReportLegList = [];
      this.tripReportLegListORI = [];
      //on each selectedJob Changed, do below.
      this.selectedJobJobNo = val[0] ? val[0]['Job Ref'] : ''; //get Job No
      this.selectedJobDestinationCode = val[0] ? val[0]['Store-M'].trim() : '';
      this.selectedJobDestinationName = val[0] ? val[0]['Store Name'].trim() : '';
      this.selectedJobJourneyAssigned = val[0] ? val[0]['Journey Assigned'] : '';

      console.log(val[0]['Total Legs']);
      let temptrip = {}
      for (let i = 1; i < Number(val[0]['Total Legs']) + 1; i++) {
        if (val[0][`Leg${i} TMSJINo`]) {
          temptrip = {}
          temptrip = {
            "Leg": i.toString(),
            "Departure": val[0] ? val[0][`Leg${i} Departure`].trim() : '',
            "Destination": val[0] ? val[0][`Leg${i} Destination`].trim() : '',
            "JobNo": val[0] ? val[0]['Job Ref'].trim() : '',
            "TMSJINo": val[0] ? val[0][`Leg${i} TMSJINo`].trim() : '',
            "Truck": val[0] ? val[0][`Leg${i} Trucks`].trim() : '',
            "Driver": val[0] ? val[0][`Leg${i} Drivers`].trim() : '',
            "PUI": val[0] ? (val[0][`Leg${i} Pick Up In Date Update`] ? val[0][`Leg${i} Pick Up In Date Update`].toString().toDate() : null) : null,
            "PUIDiff": '',
            "PUIDsbl": 'NO',
            "PUIColor": val[0] ? val[0][`Leg${i} Pick Up In Date Update`] ? this.completeColor : this.pendingColor : this.pendingColor,
            "PUO": val[0] ? val[0][`Leg${i} Pick Up Out Date Update`] ? val[0][`Leg${i} Pick Up Out Date Update`].toString().toDate() : null : null,
            "PUODiff": '',
            "PUODsbl": val[0] ? val[0][`Leg${i} Pick Up In Date Update`] ? 'NO' : 'YES' : 'YES',
            "PUOColor": val[0] ? val[0][`Leg${i} Pick Up Out Date Update`] ? this.completeColor : this.pendingColor : this.pendingColor,
            "DOI": val[0] ? val[0][`Leg${i} Drop Off In Date Update`] ? val[0][`Leg${i} Drop Off In Date Update`].toString().toDate() : null : null,
            "DOIDiff": '',
            "DOIDsbl": val[0] ? val[0][`Leg${i} Pick Up Out Date Update`] ? 'NO' : 'YES' : 'YES',
            "DOIColor": val[0] ? val[0][`Leg${i} Drop Off In Date Update`] ? this.completeColor : this.pendingColor : this.pendingColor,
            "DOO": val[0] ? val[0][`Leg${i} Drop Off Out Date Update`] ? val[0][`Leg${i} Drop Off Out Date Update`].toString().toDate() : null : null,
            "DOODiff": '',
            "DOODsbl": val[0] ? val[0][`Leg${i} Drop Off In Date Update`] ? 'NO' : 'YES' : 'YES',
            "DOOColor": val[0] ? val[0][`Leg${i} Drop Off Out Date Update`] ? this.completeColor : this.pendingColor : this.pendingColor,
          }
          console.log(temptrip);
          this.tripReportLegList.push(temptrip);
        }
      }
      console.log(this.tripReportLegList);
      this.tripReportLegListORI = JSON.parse(JSON.stringify(this.tripReportLegList));

      //leg 1
      this.selectedJobLeg1TMSJINo = val[0] ? val[0]['Leg1 TMSJINo'] ? val[0]['Leg1 TMSJINo'].trim() : '' : '';
      this.selectedJobLeg1Departure = val[0] ? val[0]['Leg1 Departure'] ? val[0]['Leg1 Departure'].trim() : '' : '';
      this.selectedJobLeg1Destination = val[0] ? val[0]['Leg1 Destination'] ? val[0]['Leg1 Destination'].trim() : '' : '';
      this.selectedJobLeg1Truck = val[0] ? val[0]['Leg1 Trucks'] ? val[0]['Leg1 Trucks'].trim() : '' : '';
      this.selectedJobLeg1Driver = val[0] ? val[0]['Leg1 Drivers'] ? val[0]['Leg1 Drivers'].trim() : '' : '';
      this.selectedJobLeg1PUI = val[0] ? val[0]['Leg 1 Pick Up In Date Update'] ? val[0]['Leg 1 Pick Up In Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg1PUIOri = val[0] ? val[0]['Leg 1 Pick Up In Date Update'] ? val[0]['Leg 1 Pick Up In Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg1PUIColor = this.selectedJobLeg1PUI ? this.completeColor : this.pendingColor; //got value then use completecolor else pendingcolor
      // this.selectedJobLeg1PUI = val[0] ? val[0]['Leg 1 Pick Up In Date Update'] : null; //get Leg 1 Pick Up In No
      // this.selectedJobLeg1PUI = this.selectedJobLeg1PUI ? this.selectedJobLeg1PUI.toString().toDate() : null; //check got value then change to date format
      this.selectedJobLeg1PUO = val[0] ? val[0]['Leg 1 Pick Up Out Date Update'] ? val[0]['Leg 1 Pick Up Out Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg1PUOOri = val[0] ? val[0]['Leg 1 Pick Up Out Date Update'] ? val[0]['Leg 1 Pick Up Out Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg1PUOColor = this.selectedJobLeg1PUO ? this.completeColor : this.pendingColor; //got value then use completecolor else pendingcolor
      // this.selectedJobLeg1PUO = val[0] ? val[0]['Leg 1 Pick Up Out Date Update'] : null; //get Leg 1 Pick Up Out No
      // this.selectedJobLeg1PUO = this.selectedJobLeg1PUO ? this.selectedJobLeg1PUO.toString().toDate() : null; //check got value then change to date format
      this.selectedJobLeg1DOI = val[0] ? val[0]['Leg 1 Drop Off In Date Update'] ? val[0]['Leg 1 Drop Off In Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg1DOIOri = val[0] ? val[0]['Leg 1 Drop Off In Date Update'] ? val[0]['Leg 1 Drop Off In Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg1DOIColor = this.selectedJobLeg1DOI ? this.completeColor : this.pendingColor; //got value then use completecolor else pendingcolor
      // this.selectedJobLeg1DOI = val[0] ? val[0]['Leg 1 Drop Off In Date Update'] : null; //get Leg 1 Pick Up In No
      // this.selectedJobLeg1DOI = this.selectedJobLeg1DOI ? this.selectedJobLeg1DOI.toString().toDate() : null; //check got value then change to date format
      this.selectedJobLeg1DOO = val[0] ? val[0]['Leg 1 Frop Off Out Date Update'] ? val[0]['Leg 1 Drop Off Out Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg1DOOOri = val[0] ? val[0]['Leg 1 Frop Off Out Date Update'] ? val[0]['Leg 1 Drop Off Out Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg1DOOColor = this.selectedJobLeg1DOO ? this.completeColor : this.pendingColor; //got value then use completecolor else pendingcolor
      // this.selectedJobLeg1DOO = val[0] ? val[0]['Leg 1 Drop Off Out Date Update'] : null; //get Leg 1 Pick Up Out No
      // this.selectedJobLeg1DOO = this.selectedJobLeg1DOO ? this.selectedJobLeg1DOO.toString().toDate() : null; //check got value then change to date format

      //leg 2
      this.selectedJobLeg2TMSJINo = val[0] ? val[0]['Leg2 TMSJINo'] ? val[0]['Leg2 TMSJINo'].trim() : '' : '';
      this.selectedJobLeg2Departure = val[0] ? val[0]['Leg2 Departure'] ? val[0]['Leg2 Departure'].trim() : '' : '';
      this.selectedJobLeg2Destination = val[0] ? val[0]['Leg2 Destination'] ? val[0]['Leg2 Destination'].trim() : '' : '';
      this.selectedJobLeg2Truck = val[0] ? val[0]['Leg2 Trucks'] ? val[0]['Leg2 Trucks'].trim() : '' : '';
      this.selectedJobLeg2Driver = val[0] ? val[0]['Leg2 Drivers'] ? val[0]['Leg2 Drivers'].trim() : '' : '';
      this.selectedJobLeg2PUI = val[0] ? val[0]['Leg 2 Pick Up In Date Update'] ? val[0]['Leg 2 Pick Up In Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg2PUIOri = val[0] ? val[0]['Leg 2 Pick Up In Date Update'] ? val[0]['Leg 2 Pick Up In Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg2PUIColor = this.selectedJobLeg2PUI ? this.completeColor : this.pendingColor; //got value then use completecolor else pendingcolor
      this.selectedJobLeg2PUO = val[0] ? val[0]['Leg 2 Pick Up Out Date Update'] ? val[0]['Leg 2 Pick Up Out Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg2PUOOri = val[0] ? val[0]['Leg 2 Pick Up Out Date Update'] ? val[0]['Leg 2 Pick Up Out Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg2PUOColor = this.selectedJobLeg2PUO ? this.completeColor : this.pendingColor; //got value then use completecolor else pendingcolor
      this.selectedJobLeg2DOI = val[0] ? val[0]['Leg 2 Drop Off In Date Update'] ? val[0]['Leg 2 Drop Off In Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg2DOIOri = val[0] ? val[0]['Leg 2 Drop Off In Date Update'] ? val[0]['Leg 2 Drop Off In Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg2DOIColor = this.selectedJobLeg2DOI ? this.completeColor : this.pendingColor; //got value then use completecolor else pendingcolor
      this.selectedJobLeg2DOO = val[0] ? val[0]['Leg 2 Drop Off Out Date Update'] ? val[0]['Leg 2 Drop Off Out Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg2DOOOri = val[0] ? val[0]['Leg 2 Drop Off Out Date Update'] ? val[0]['Leg 2 Drop Off Out Date Update'].toString().toDate() : null : null;
      this.selectedJobLeg2DOOColor = this.selectedJobLeg2DOO ? this.completeColor : this.pendingColor; //got value then use completecolor else pendingcolor
    
      //disabled legs
      // console.log(this.selectedJobJourneyAssigned);
      this.selectedJobTotalLegs = val[0] ? val[0]['Total Legs'] : '0';
      this.selectedJobLegsNotAssigned = val[0] ? val[0]['Legs Not Assigned'] : null;
      this.selectedJobLegsNotAssignedArray = this.selectedJobLegsNotAssigned ? this.selectedJobLegsNotAssigned.split(',') : [];
      console.log(this.selectedJobLegsNotAssignedArray);
      
      if (this.selectedJobTotalLegs == '0') {
        this.selectedJobLeg1Display = 'none';
        this.selectedJobLeg2Display = 'none';
      } else if (this.selectedJobTotalLegs == '1') {
        this.selectedJobLeg1Display = '';
        this.selectedJobLeg2Display = 'none';
      } else if (this.selectedJobTotalLegs == '2') {
        this.selectedJobLeg1Display = '';
        this.selectedJobLeg2Display = '';
        // this.selectedJobLeg3Display = 'none';
      } else {
        this.selectedJobLeg1Display = 'none';
        this.selectedJobLeg2Display = 'none';
      }

      if (this.selectedJobJourneyAssigned) {
        if (this.selectedJobJourneyAssigned == 'Complete') {
          this.selectedJobLeg1Disabled = false;
          this.selectedJobLeg2Disabled = false;
        } else {
          if (this.selectedJobLegsNotAssignedArray.length > 0) {
            this.selectedJobLegsNotAssignedArray.forEach(a => {
              if (a == 1) {
                this.selectedJobLeg1Display = 'none';
              } 
              if (a == 2) {
                this.selectedJobLeg2Display = 'none';
              }
            })
          }
        }
      } else {
        this.selectedJobLeg1Disabled = true;
        this.selectedJobLeg2Disabled = true;
      }
    },

    updateResult: function(val) {
      this.$nextTick(() => this.$refs.msgbox.scrollTop = this.$refs.msgbox.scrollHeight + 100);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

// @media only screen and (max-width: 700px) {
//   div{
//     font-size: 9px;
//   }
// }

.trip-report-main {
  width: 100%;
  height: 100%;
  font-size: 12px;
  display: flex;
  padding: 10px 45px;

  > .sidenav {
    width: 200px;
    background-color: white;
    border-radius: 5px;
    margin-right: 5px;
    transition: $transition-time;

    >.refreshButton {
      width: 100%;
      text-align: right;
      float: right;
      top: 80px;
    
      button{
        position: relative;
        align-self: center;
        top: 80px;
        margin: 2px 0px;
        padding: 5px;
        width: auto;
      }
      button:hover{
        background:  rgba(128,128,128,0.3);
      }

      img {
        height: 28px;
        width: 28px;
        padding: 2px;
        cursor: pointer;
        border-radius: 3px;
        transition: $transition-time;
        position: sticky;
      }

      img:hover {
        background-color: rgba(128,128,128,0.3);
      }
    }
  }

  > .right-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    > .top-filter, > .table {
      padding: 5px;
      background-color: white;
      border-radius: 5px;
    }

    > .top-filter {
      display: flex;
      flex-direction: column;
      min-height: 80px;
      max-height: 80px;
      margin-bottom: 5px;
      justify-content: center;

      > .refresh-details {
        display: flex;
        align-items: center;

        > .caption {
          min-width: 110px;
          max-width: 110px;
        }
      }
    }

    > .table {
      position: relative;
      height: calc(100% - 85px); //85px
      margin-bottom: unset;

      > .table-container {
        background-color: white;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        padding: 5px;
      }
    }
  }

  >.tableBtn {
      padding: 4px;
      position: absolute;
      top: 0px;
      left: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 20;
  }

  >.tableDiv {
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: white;
    margin-top: 5px;
    border-radius: 5px;
    height: 100%;
    padding: 5px;
  }
  
  .tableBtn:focus {
    box-shadow: none;
  }

  .tableBtn > img {
    width: 20px;
    height: 20px;
  }

  .tableBtn > svg {
    width: 20px;
    height: 20px;
  }

  .tableBtnLabel {
    width: auto;
    height: 100%;
    margin: 0 0 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > .attachment-popup {
    background-color: rgba(128,128,128,0.5);
    position: fixed;
    top: 50px;
    left: 0;
    height: calc(100% - 50px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;

    > .content {
      height: 90%;
      width: 60%;
      background-color: white;
      display: flex;
      flex-direction: column;
      padding: 5px;
      border-radius: 5px;
      position: relative;

      > .close-icon, > .left-icon, > .right-icon {
        height: 25px;
        width: 25px;
        position: absolute;
        top: 5px;
        right: 5px;
        opacity: 0.75;
        cursor: pointer;

        &:hover {
          opacity: 1;
        }
      }

      > .left-icon, > .right-icon {
        opacity: 0.25;
        height: 50px;
        width: 50px;
        top: calc(50% - 25px);
      }

      > .left-icon {
        left: 10px;
        transform: rotate(180deg);
      }

      > .right-icon {
        right: 10px;
      }

      > object {
        background-color: lightgray;
        height: calc(100% - 90px);
        object-fit: contain;
      }

      > .title, > .caption {
        width: 100%;
        font-size: 1.1em;
        font-weight: bold;
        text-align: center;
        margin: 5px 0;
      }
    }
  }
}

.right-menu {
  display: flex; 
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #F0F8FF;
  position: relative;
  overflow: hidden;

  > .RMheader {
    position: relative;
    height: 100px;
    width: 100%;
    top: 0;
    
    > .RMmaindetails {
    border: 1px solid black;
    border-radius: 5px;
    background-color: #535cda;
    color: white;

      > .RMdetails {
        display: flex;
        margin-left: 5px;

        > .RMcaption {
          min-width: 120px;
          max-width: 120px;
        }
      }
   }

  }

    > .updateAllCheckBox {
      margin-top: 5px;
      margin-bottom: 5px;
    }

  > .RMbody {
    height: 100%;
    overflow: auto;

  > div > .RMleg {
    border: 1px solid black;
    border-radius: 5px;
    background-color: white;
    margin-top: 5px;

    > .RMlegdetails {
      margin-bottom: 5px;
      margin-left: 5px;
      position: relative;

      > p {
        font-size: 1.1em; 
        font-weight: bold; 
        margin-top: 3px; 
        margin-bottom: 3px;
      }

      > .RMdetails {
        display: flex;

        > .RMcaption {
        min-width: 120px;
        max-width: 120px;
        }
      }
    }

    > .RMmainstatus {
      // display: flex;
      // flex-direction: row;
      display: grid;
      grid-template-columns: 50% 50%;
      width: 100%;

      > .RMstatus {
        border: 1px solid black;
        // width: 50%;
        border-radius: 5px;
        // margin: 5px;
        width: calc(100% - 10px);
        margin-bottom: 5px;
        // margin-left: 5px;

        > .RMstatushead {
          display: flex;
          flex-direction: row;
          position: relative;

          > p {
            margin-bottom: 10px;
            margin-top: 5px;
          }

          > .statusbutton {
            position: absolute;
            top: 4px;
            right: 5px;
            padding: 5px;
            padding-top: 1px;
            padding-bottom: 1px;
          }

        }

        > * {
          margin-left: 3px;
        }
      }
    }
  }

  // > .RMleg {
    
  // }

  > .RMleg1, .RMleg2 {
    border: 1px solid black;
    border-radius: 5px;

    > .RMleg1details, .RMleg2details {
      margin-bottom: 5px;
      margin-left: 5px;

      > .RMdetails {
        display: flex;

        > .RMcaption {
        min-width: 120px;
        max-width: 120px;
      }
      }
    }

    > .RMpickup {
      > .RMpickupin, .RMpickupout {
        border: 1px solid black;
        width: 50%;
        border-radius: 5px;
        margin: 5px;

        > * {
          margin-left: 3px;
        }
      }
    }

    > .RMdropoff {
      > .RMdropoffin, .RMdropoffout {
        border: 1px solid black;
        width: 50%;
        border-radius: 5px;
        margin: 5px;

        > * {
          margin-left: 3px;
        }
      }
    }
  }
  }

  > .RMfooter {
    bottom: 0;
    min-height: 80px;
    max-height: 80px;
    width: 100%;
    background-color: #535cda;
    color: black;
    display: flex;
    flex-direction: row;
    // border-top: 1px solid black;
    border: 1px solid black;
    // border-radius: 5px;

    // position: relative;

    > .message-box {
      // margin-left: 5px;
      // padding: 5px;
      flex-grow: 1;
      overflow: auto;
      // background-color: rgba(255, 246, 121, 0.37);
      background-color: white;
      height: 100%;
      flex: 3;
      z-index: 999;
      // background-blend-mode: normal;
      // position: absolute;
    }

    > .save-all-div {
      width: 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;

      > .save-all {
      // position: absolute;
      // top: 50%;
      width: fit-content;
      height: fit-content;
      // margin-top: auto;
      // margin-bottom: auto;
      }
    }
    
    // > .message-box {
    //     flex-grow: 1;
    //     margin-right: 5px;
    //     background-color: rgba(255, 246, 121, 0.37);
    //     overflow: auto;
    //     height: 100%;
    //     padding-left: 5px;
    //     width: 60%;
    //     white-space: pre-wrap;
    //     overflow: auto;
    //   }
  }
}
</style>